import { render, staticRenderFns } from "./TemplateBoolean.vue?vue&type=template&id=87c2a5c0&"
import script from "./TemplateBoolean.vue?vue&type=script&lang=js&"
export * from "./TemplateBoolean.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports